import { ButtonContainer } from "./Button.styles";

const Button = ({
  title,
  onClick,
  leftIcon,
  rightIcon,
  style,
  disabled,
  loading,
  background,
  textColor,
}) => {
  return loading ? (
    <ButtonContainer style={style} disabled>
      <l-line-spinner size="20" stroke="2" speed="1" color="#000" />
    </ButtonContainer>
  ) : (
    <ButtonContainer
      style={style}
      onClick={onClick}
      disabled={disabled}
      $background={background}
      $textColor={textColor}
    >
      {leftIcon}
      {title}
      {rightIcon}
    </ButtonContainer>
  );
};

export default Button;
